import styles from "../../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from "react";
import Notification from "utils/Notifications";
import { Button } from "components";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import {
    getEmployeesData
} from "service/AccountingService";
import EmployeeDetailContent from "./component/EmployeeDetailContent";
import { Icon } from '../../../../components/UnvUI/Icons'

const EmployeeContent = ({ render, setRender, id }) => {
  const { t } = useTranslation('common')

    const componentRef = useRef();


    const [data, setData] = useState([]);
    const getData = async () => {
        try {
            let response = await getEmployeesData(id);
            setData(response.data);
        } catch (error) {
        }
    };

    useEffect(() => {
        getData();
        setRender(false);
        // eslint-disable-next-line
    }, [render]);

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });


    const [searchName, setSearchName] = useState("");
    const [searchSurname, setSearchSurname] = useState("");
    const [searchInn, setSearchInn] = useState("");
    const [searchDepartment, setSearchDepartment] = useState("");
    const [searchPosition, setSearchPosition] = useState("");
    const [searchStatus, setSearchStatus] = useState("");

    const filteredData = Array.isArray(data)
        ? data.filter((item) => {
            const matchName = searchName
                ? item.personaldata?.first_name?.toLowerCase().includes(searchName.toLowerCase())
                : true;
            const matchSurname = searchSurname
                ? item.personaldata?.surname?.toLowerCase().includes(searchSurname.toLowerCase())
                : true;
            const matchInn = searchInn
                ? item.personaldata?.inn?.toLowerCase().includes(searchInn.toLowerCase())
                : true;
            const matchDepartment = searchDepartment
                ? item.department_name?.toLowerCase().includes(searchDepartment.toLowerCase())
                : true;
            const matchPosition = searchPosition
                ? item.posititon_name?.toLowerCase().includes(searchPosition.toLowerCase())
                : true;
            const matchStatus = searchStatus
                ? item.status?.toLowerCase().includes(searchStatus.toLowerCase())
                : true;
            return (
                matchName &&
                matchSurname &&
                matchInn &&
                matchDepartment &&
                matchPosition &&
                matchStatus
            );
        })
        : [];

    const clearFilters = () => {
        setSearchName("");
        setSearchSurname("");
        setSearchInn("");
        setSearchDepartment("");
        setSearchPosition("");
        setSearchStatus("");
        setCurrentPage(1);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const [openWindowId, setOpenWindowId] = useState(null);
    const [openWindowName, setOpenWindowName] = useState(null);

    const handleOpenWindow = (item) => {
        setOpenWindowId(item.id);
        setOpenWindowName(item?.personaldata?.surname + " " + item?.personaldata?.first_name);
    };

    const handleCloseWindow = () => {
        setOpenWindowId(null);
        setOpenWindowName("");
    };

    return (
        <>
            {!openWindowId && (
                <>
                    <div className={styles.content_header}>
                        <h2 className={styles.project__h}>{t('menu.employees')}</h2>
                        <button className={styles.btn_print} onClick={handlePrint}>
                            {t('auto.components_academicyearcontent.k1')}
                        </button>

                    </div>
                    
                    <div className={styles.div_search}>
                        <h2 className={styles.project__h}>{t('common.filter')}</h2>
                        <div>
                            <input
                                type="text"
                                placeholder={t('auto.employeecontent_employeecontent.k8')}
                                value={searchInn}
                                onChange={(e) => setSearchInn(e.target.value)}
                                style={{ width: "30%" }}
                            />
                            <input
                                type="text"
                                placeholder={t('auto.employeecontent_employeecontent.k9')}
                                value={searchSurname}
                                onChange={(e) => setSearchSurname(e.target.value)}
                                style={{ width: "30%" }}
                            />
                            <input
                                type="text"
                                placeholder={t('auto.employeecontent_employeecontent.k10')}
                                value={searchName}
                                onChange={(e) => setSearchName(e.target.value)}
                                style={{ width: "30%" }}
                            />

                            <input
                                type="text"
                                placeholder={t('employees.department')}
                                value={searchDepartment}
                                onChange={(e) => setSearchDepartment(e.target.value)}
                                style={{ width: "30%" }}
                            />
                            <input
                                type="text"
                                placeholder={t('archive.col_position')}
                                value={searchPosition}
                                onChange={(e) => setSearchPosition(e.target.value)}
                                style={{ width: "30%" }}
                            />
                            <select
                                value={searchStatus}
                                onChange={(e) => setSearchStatus(e.target.value)}
                                style={{ width: "30%" }}
                            >
                                <option value="">{t('pages.ordersPage.all_statuses')}</option>
                                <option value="Работает">{t('auto.employeecontent_employeecontent.k1')}</option>
                                <option value="Уволен(а)">{t('auto.employeecontent_employeecontent.k2')}</option>
                                <option value="В отпуске">{t('auto.employeecontent_employeecontent.k3')}</option>
                                <option value="В командировке">{t('auto.employeecontent_employeecontent.k4')}</option>
                                <option value="На больничном">{t('auto.employeecontent_employeecontent.k5')}</option>
                                <option value="В декретном отпуске">{t('auto.employeecontent_employeecontent.k6')}</option>
                                <option value="В отпуске без содержания">{t('auto.employeecontent_employeecontent.k7')}</option>
                            </select>
                            <Button onClick={clearFilters} className={styles.clear__button}>
                                Очистить
                            </Button>
                        </div>
                    </div>
                    
                    <table ref={componentRef} className={styles.table__wrapper}>
                        <thead className={styles.table__head}>
                            <tr className={styles.table__row}>
                                <th className={styles.table__item_student}>№</th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('auth.inn')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('user.last_name')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('user.first_name')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('user.middle_name')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('user.phone')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('employees.department')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('archive.col_position')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('employees.rate')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('statements.list.order')}</span>
                                </th>
                                <th className={styles.table__item_student}>
                                    <span className={styles.table__title}>{t('common.status')}</span>
                                </th>
                                <th className={styles.table__item__nav}>
                                    <span className={styles.table__title}>{t('common.actions')}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className={styles.table__body}>
                            {currentItems.map((item, index) => (
                                <tr className={styles.table__row} key={item.id}>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title}>
                                            {index + 1 + (currentPage - 1) * itemsPerPage}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item?.personaldata?.inn}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item?.personaldata?.surname}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item?.personaldata?.first_name}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item?.personaldata?.last_name}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item?.personaldata?.number_phone}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item.department_name}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item.posititon_name}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item.stavka}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span className={styles.table__title} style={{ fontWeight: "700" }}>
                                            {item.order}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <span
                                            className={styles.table__title}
                                            style={{
                                                fontWeight: "700",
                                                padding: "5px",
                                                borderRadius: "6px",
                                                display: "block",
                                                textAlign: "center",
                                                background:
                                                    item.status === "Работает"
                                                        ? "#5C5CFF"
                                                        : item.status === "Уволен(а)"
                                                            ? "#a00000ff"
                                                            : item.status === "В отпуске"
                                                                ? "#ec9900ff"
                                                                : item.status === "В командировке"
                                                                    ? "#333333"
                                                                    : item.status === "На больничном"
                                                                        ? "#0a62a3"
                                                                        : item.status === "В декретном отпуске"
                                                                            ? "#ffb6c1"
                                                                            : item.status === "В отпуске без содержания"
                                                                                ? "#999"
                                                                                : "transparent",
                                                color: item.status ? "white" : "inherit",
                                            }}
                                        >
                                            {item.status || ""}
                                        </span>
                                    </td>
                                    <td className={styles.table__item_student}>
                                        <div className={styles.table__item__div}>
                                            <button
                                                onClick={() => handleOpenWindow(item)}
                                                className={styles.editBtn}
                                            >
                                                <Icon name="folder" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <div className={styles.pagination}>
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    style={{
                                        padding: "5px 10px",
                                        background: currentPage === page ? "#736CED" : "#f0f0f0",
                                        color: currentPage === page ? "#fff" : "#000",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                >
                                    {page}
                                </button>
                            ))}
                        </div>
                    </table>


                </>
            )}

            {openWindowId && (
                <EmployeeDetailContent
                    id={openWindowId}
                    render={render}
                    foun_id={id}
                    setRender={setRender}
                    nameEmployee={openWindowName}
                    onBack={handleCloseWindow}
                />
            )}

            <Notification notify={notify} setNotify={setNotify} />
        </>
    );
};
export default EmployeeContent;